import { Component, Input } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { Incidente } from '../incidente/incidente';
import { IncidenteService } from '../incidente/incidente.service';
import { Finalizacao } from '../incidente/finalizacao';

@Component({
  selector: 'app-modal-finaliz',
  template: `
  <div id="modalf" (click)="onContainerClicked($event)" class="modal fade" tabindex="-1" [ngClass]="{'in': visibleAnimate}"
       [ngStyle]="{'display': visible ? 'block' : 'none', 'opacity': visibleAnimate ? 1 : 0}">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" (click)="closeModal();">&times;</button>
        <h4 class="modal-title">Finalização do incidente</h4>
          <ng-content select=".app-modal-header"></ng-content>
        </div>
        <form id="login-form">
        <div class="modal-body">
            <label for="selectClassificacao">Tipos de finalização</label>
            <p class="help-block">Marque uma opção</p>
            <div class="radio" *ngFor="let finalizacao of finalizacoes">
              <label>
              <input type="radio" name="finaliz" value="{{finalizacao.id}}" [(ngModel)]="finaliz">{{finalizacao.nome}}
              </label>
            </div>
            <br />
            <label for="selectDescricao">Descrição:</label>
            <textarea class="form-control" rows="3" id="inputDescricao" name="descricaofinaliz" [(ngModel)]="desc" placeholder="Descreva o tipo de finalização."></textarea>
            <ng-content select=".app-modal-body"></ng-content>
        </div>
        <div class="modal-footer">
            <div class="col-sm-offset-2 col-sm-10">
            <button type="button" class="btn btn-default" (click)="closeModal();">Fechar</button>
            <button class="btn btn-success" (click)="salvarFinalizacao();" data-dismiss="modalr">Salvar</button>
            </div>
          <ng-content select=".app-modal-footer"></ng-content>
        </div>
        </form>
      </div>
    </div>
  </div>
  `,
  styles: [`
    .modal {
      background: rgba(0,0,0,0.6);
    }
  `],
  providers: [
    IncidenteService
  ]
})
export class ModalFinalizacaoComponent {

  public visible = false;
  private visibleAnimate = false;

  incidente: Incidente;

  finalizacoes: Finalizacao[];

  descricaofinaliz: string;

  @Input() desc:string;
  @Input() idInc: number;
  @Input() finaliz: number;

  constructor(private incidenteService: IncidenteService, private router: Router){
  }

  public show(id): void {

    //console.log(id);

    this.visible = true;
    setTimeout(() => this.visibleAnimate = true, 100);

    this.idInc = id;
    this.incidenteService.getFinalizacao()
    .then((finalizacao) => this.finalizacoes = finalizacao);

  }

  public hide(): void {
    this.visibleAnimate = false;
    setTimeout(() => this.visible = false, 300);
  }

  public closeModal(): void {
    this.visibleAnimate = false;
    setTimeout(() => this.visible = false, 300);
  }

  public onContainerClicked(event: MouseEvent): void {
    if ((<HTMLElement>event.target).classList.contains('modal')) {
      this.hide();
    }
  }


  public salvarFinalizacao(): void {
    this.incidente = new Incidente;

    // definindo o id do incidente, o resumo do caso e a classificacao
    this.incidente.id = this.idInc;
    this.incidente.descricaofinaliz = this.desc;
    this.incidente.finaliz = this.finaliz;

    //console.log(this.incidente);


    this.incidenteService.salvarFinalizacao(this.incidente)
        .then((resposta) => this.goBack(resposta))

    // fecha a janela modal
    this.hide();

  }

  goBack(resposta: any): void {
     alert(resposta);
     window.location.reload();
  }

}



// WEBPACK FOOTER //
// ./src/app/denuncias/modalfinalizacao.component.ts